import { TextProps } from './styleModels';
import { MultiLanguageText } from './MultiLanguageText';

export class FeaturesItem {
  constructor(item = {}) {
    this.guid = item.guid || '-1';
    this.legendName = new MultiLanguageText(item.legend_name);
    this.image = item.image || '';
    this.featureTitleProps = new TextProps(
      item.featureTitleProps || {}
    );
  }
}
